import { Link } from "react-router-dom";
import { SITE, NAV } from "@/lib/site";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--ss-teal-900)] text-[var(--ss-cream)] relative overflow-hidden"
    >
      {/* Decorative top wave */}
      <div className="absolute top-0 left-0 right-0 -translate-y-px">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" className="w-full h-[40px] block">
          <path
            d="M0,30 C240,60 480,0 720,20 C960,40 1200,55 1440,25 L1440,60 L0,60 Z"
            fill="var(--ss-teal-900)"
          />
        </svg>
      </div>

      <div className="container-px max-w-7xl mx-auto pt-20 pb-10 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo variant="light" size="lg" withStrapline={true} testId="footer-logo" />
          <p className="mt-6 max-w-md text-[var(--ss-cream)]/80 leading-relaxed">
            A local, family-run, premium domiciliary and live-in care company
            covering Epping Forest, Harlow and Bishop's Stortford. CQC Rated <em className="text-[var(--ss-gold)] not-italic">Good</em>, with the same trusted
            carer for every visit.
          </p>

          <div className="mt-8 grid gap-3 max-w-md">
            <a
              href={SITE.phoneHref}
              data-testid="footer-phone"
              className="flex items-center gap-3 group"
            >
              <span className="w-10 h-10 rounded-full bg-[var(--ss-teal-800)] border border-[var(--ss-cream)]/15 flex items-center justify-center text-[var(--ss-gold)]">
                <i className="fa-solid fa-phone"></i>
              </span>
              <div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--ss-cream)]/60">
                  Care line · 24/7
                </div>
                <div className="font-serif text-2xl group-hover:text-[var(--ss-gold)] transition-colors">
                  {SITE.phone}
                </div>
              </div>
            </a>
            <a
              href={SITE.emailHref}
              data-testid="footer-email"
              className="flex items-center gap-3 group"
            >
              <span className="w-10 h-10 rounded-full bg-[var(--ss-teal-800)] border border-[var(--ss-cream)]/15 flex items-center justify-center text-[var(--ss-gold)]">
                <i className="fa-regular fa-envelope"></i>
              </span>
              <div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--ss-cream)]/60">
                  Email us
                </div>
                <div className="text-lg group-hover:text-[var(--ss-gold)] transition-colors">
                  {SITE.email}
                </div>
              </div>
            </a>
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 rounded-full bg-[var(--ss-teal-800)] border border-[var(--ss-cream)]/15 flex items-center justify-center text-[var(--ss-gold)]">
                <i className="fa-solid fa-location-dot"></i>
              </span>
              <div className="leading-relaxed">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--ss-cream)]/60">
                  Where we work
                </div>
                <div>Epping Forest &amp; Harlow</div>
                <div>Essex, United Kingdom</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--ss-gold)] mb-5">
            Explore
          </div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  className="text-[var(--ss-cream)]/85 hover:text-[var(--ss-gold)] transition-colors link-underline"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--ss-gold)] mb-5">
            Regulated &amp; Trusted
          </div>
          <ul className="space-y-3 text-[var(--ss-cream)]/85">
            <li><i className="fa-solid fa-award text-[var(--ss-gold)] mr-2"></i> CQC Rated Good</li>
            <li><i className="fa-solid fa-shield-halved text-[var(--ss-gold)] mr-2"></i> UKHCA Member</li>
            <li><i className="fa-solid fa-handshake text-[var(--ss-gold)] mr-2"></i> Essex Care Association</li>
            <li><i className="fa-solid fa-hand-holding-heart text-[var(--ss-gold)] mr-2"></i> Family-run since day one</li>
          </ul>

          <Link
            to="/contact#enquiry-form"
            data-testid="footer-cta-book"
            className="btn btn-gold mt-7 w-full sm:w-auto"
          >
            Book Free Assessment
          </Link>
        </div>
      </div>

      <div className="border-t border-[var(--ss-cream)]/10">
        <div className="container-px max-w-7xl mx-auto py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[var(--ss-cream)]/60">
          <div>
            © {new Date().getFullYear()} SeaShells Care Ltd. All rights reserved.
          </div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-[var(--ss-gold)]">Privacy</Link>
            <Link to="/cookies" className="hover:text-[var(--ss-gold)]">Cookies</Link>
            <Link to="/safeguarding" className="hover:text-[var(--ss-gold)]">Safeguarding</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
